
import angular from 'angular';

const componentOptions = {
    bindings: {
        model: '=',
        containerForm: '=?',
        index: '<?',
        sliderDisabled: '=?'
    },
    controllerAs: 'bidsSliderCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-bids-slider.html';
    }]
};


const componentInfo = {
    module: 'ib-bids-slider-module',
    selector: 'ibBidsSlider',
    inject: ['$scope', '$timeout', '$rootScope', '$filter', 'AncillariesConstants'],
    required: ['']
};


export class ibBidsSlider implements ng.IController {
    public model;
    public PRICE_INTEGER;
    public PHONE_CLEANER;
    public off;
    public preBids;
    public valuePrice;
    public animationBig;
    public animationSmall;
    public animationMaxFraud;
    public tooltipText;
    public dataId;
    public publicmaxBids;
    public minBids;
    public noneBids;
    public rangeBids;
    public slider;
    public maxBids;
    public maxFraud;
    public containerForm;
    public index;
    public sliderDisabled: boolean;

    constructor (
        private $scope,
        private $timeout: ng.ITimeoutService,
        private $rootScope: CommonsRootScope,
        private $filter: angular.IFilterService,
        private AncillariesConstants: AncillariesConstant
    ) {
        this.PRICE_INTEGER = this.AncillariesConstants.PATTERNS.PRICE_INTEGER;
        this.PHONE_CLEANER = AncillariesConstants.PATTERNS.PHONE_CLEANER;
        this.$scope.$on('disableSlider', this.disableSlider);
    }

    reset = (): void => {
        this.slider.value = this.preBids ? this.preBids : 0;
        this.$scope.$broadcast('rzSliderForceRender');
    };

    myChangeListener = (): void => {
        if (this.slider.value === this.slider.options.floor) {
            this.slider.value = 0;
            this.valuePrice = 0;
            this.reset();
            this.off = true;
        }
        if (this.containerForm && this.index) {
            this.containerForm['slider_' + this.index] = 0;
        }
        this.$rootScope.$broadcast('updateTotalPrice', this.slider);
    };

    message = (val: number): void => {
        const sectionOne = this.model.minimumAllowedBid + (this.rangeBids * 2);
        const sectionTwo = sectionOne + (this.rangeBids * 2);
        const textMin = this.$filter('translate')('MMB_UPGRADING_BIDS_TOOLTIP_BID_1');
        const textMedium = this.$filter('translate')('MMB_UPGRADING_BIDS_TOOLTIP_BID_2');
        const textMax = this.$filter('translate')('MMB_UPGRADING_BIDS_TOOLTIP_BID_3');
        const min = this.minBids;

        if (val >= min && val <= sectionOne) {
            this.tooltipText = textMin;
            angular.element('.ib-tooltip--fade-out').delay(5000).fadeOut(500);
        } else if (val > sectionOne && val <= sectionTwo) {
            this.tooltipText = textMedium;
            angular.element('.ib-tooltip--fade-out').delay(5000).fadeOut(500);
        } else if (val > sectionTwo) {
            this.tooltipText = textMax;
            angular.element('.ib-tooltip--fade-out').delay(5000).fadeOut(500);
        } else if (val < this.preBids) {
            this.animationSmall = true;
            this.$timeout(() => {
                this.animationSmall = false;
            }, 5000);
        } else {
            this.tooltipText = '';
        }
    };

    $onInit (): void {
        this.PRICE_INTEGER = this.AncillariesConstants.PATTERNS.PRICE_INTEGER;
        this.PHONE_CLEANER = this.AncillariesConstants.PATTERNS.PHONE_CLEANER;
        this.off = true;
        this.preBids = this.model.currentBidByPax ? this.model.currentBidByPax : false; //Puja previa, si es la primera poner "false"
        this.valuePrice = this.preBids ? this.preBids : 0;
        this.animationBig = false;
        this.animationSmall = false;
        this.tooltipText = '';
        this.dataId = this.$scope.$id;
        this.maxBids = this.model.maximumExpectedBid <= this.model.currentBidByPax ? this.model.currentBidByPax : this.model.maximumExpectedBid;
        this.minBids =  this.model.currentBidByPax ? this.model.currentBidByPax : this.model.minimumAllowedBid;
        this.maxFraud = this.model.maxFraud;
        this.noneBids = this.minBids - 1;
        this.rangeBids = (this.maxBids - this.model.minimumAllowedBid) / 5;
        this.slider = {
            value: this.preBids ? this.preBids : this.minBids - 1, //Valor inicial
            options: {
                disabled: this.sliderDisabled,
                precision: 0,
                minLimit: this.preBids ? this.preBids : null, // Minimo permitido
                hideLimitLabels: false,
                floor: this.preBids ? this.model.minimumAllowedBid : this.minBids - 1,
                ceil: this.model.maximumExpectedBid,
                step: 1,
                id: this.dataId.toString() + '_' + this.model.id + '_' + this.model.cabinType,
                ticksArray: [this.minBids, this.maxBids],
                onChange: this.myChangeListener,
                showTicksValues: true,
                showSelectionBar: true,
                translate: () => {
                    this.valuePrice = this.slider.value;
                    if (this.valuePrice === this.slider.options.floor && !this.preBids) {
                        this.valuePrice = 0;
                        this.slider.value = 0;
                    }

                    this.message(this.slider.value);
                    this.valuePrice = this.slider.value;
                    if (this.tooltipText === '') {
                        return '';
                    }

                    return (
                        '<div class="ib-tooltip ib-tooltip--fade-out"><div class="ib-tooltip__box ib-tooltip__box--big"><p class="ib-tooltip__text ib-tooltip__text--small">' +
                        this.tooltipText +
                        '</p></div></div>'
                    );
                },
                getPointerColor: () => {
                    if(this.slider.value > 0) {
                        return '#D7192D';
                    } else {
                        return '#666666';
                    }
                },
                onEnd: () => {
                    if (this.slider.value < this.minBids) {
                        this.reset();
                        this.off = true;
                    } else if (this.slider.value >= this.maxBids) {
                        this.slider.value = this.maxBids;
                        this.$rootScope.$broadcast('updateTotalPrice', this.slider);
                    } else {
                        this.off = false;
                    }
                    this.$scope.$emit('sliderOff', this.off);
                }
            }
        };
        if(this.preBids) {
            this.showAnimationSmall();
        }
        this.$timeout(() => {
            this.$scope.$broadcast('reCalcViewDimensions');
        }, 50);
    }

    updatePrice = (): void => {
        const maxFraud: number = this.maxFraud;
        const min: number = this.preBids ? this.preBids : this.minBids;
        const val: number = parseInt(this.valuePrice);
        if (this.preBids && val < min) {
            this.valuePrice = this.preBids;
            this.slider.value = this.preBids;
            this.showAnimationSmall();
            this.off = false;
            if (this.containerForm && this.index) {
                this.containerForm['slider_' + this.index] = 0;
            }
        } else if ((val === 0 && !this.preBids) || this.valuePrice === '') {
            this.reset();
            this.off = true;
            this.slider.value = 0;
            if (this.containerForm && this.index) {
                this.containerForm['slider_' + this.index] = 0;
            }
        } else if (val < min || val < this.preBids) {
            this.showAnimationSmall();
            this.valuePrice = min;
            this.slider.value = min;
            this.off = false;
        } else if (val > maxFraud) {
            this.showAnimationMaxFraud();
            this.valuePrice = maxFraud;
            this.slider.value = maxFraud;
            this.off = false;
        } else {
            this.slider.value = val;
            this.animationBig = false;
            this.animationSmall = false;
            this.off = false;
            if (this.containerForm && this.index) {
                this.containerForm['slider_' + this.index] = 0;
            }
        }
        this.$rootScope.$broadcast('updateTotalPrice', this.slider);
        this.$scope.$emit('sliderOff', this.off);
    };

    showAnimationSmall (): void {
        this.animationSmall = true;
        this.$timeout(() => {
            this.animationSmall = false;
        }, 5000);
    }

    showAnimationMaxFraud (): void {
        this.animationMaxFraud = true;
        this.$timeout(() => {
            this.animationMaxFraud = false;
        }, 5000);
    }

    resetPrevBids = (): void => {
        if (!this.preBids) {
            this.slider.value = 0;
        } else {
            this.slider.value = this.preBids;
        }
        this.$scope.$broadcast('rzSliderForceRender');
    };

    openCancelOffer = (): void => {
        this.$rootScope.$broadcast('openCancelOffer', this.model, this.model.cabinType);
    };
    disableSlider = (e, cabin): void => {
        if (cabin.id === this.$scope.$parent?.cabin.id && cabin.cabinType === this.$scope.$parent?.cabin.cabinType) {
            this.reset();
            this.off = true;
            this.$scope.$emit('sliderOff', this.off);
        }
    };

    onFocusBidBox = (): void => {
        if (this.valuePrice === 0) {
            this.valuePrice = '';
        }
    };

}


try {
    const mod = angular.module(componentInfo.module);
    ibBidsSlider.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBidsSlider })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibBidsSlider.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBidsSlider })
    );
}